import { TrackedButton, Typography } from '@automata/ui';
import { Stack } from '@mui/material';

export type Props = {
  onClickReturnToWorkflow: () => void;
  errorMessage: string;
};

const PreviewPlanningFailedDisplay = ({
  onClickReturnToWorkflow,
  errorMessage,
}: Props): JSX.Element => {
  return (
    <Stack p={3}>
      <Stack justifyContent="center" alignItems="center" paddingY={4} gap={2}>
        <Typography variant="h4" component="h2">
          Planning failed
        </Typography>
        <Typography
          variant="subtitle1"
          component="h3"
          sx={{ textAlign: 'center' }}
        >
          The last planned workflow failed to plan with the following error(s).
        </Typography>
        <Typography
          variant="body1"
          component="p"
          sx={{ textAlign: 'center', maxWidth: 720 }}
        >
          {errorMessage}
        </Typography>
        <Typography
          variant="subtitle1"
          component="p"
          sx={{ textAlign: 'center' }}
        >
          You can return to workflow builder to make changes or adjust planning
          options and try again.
        </Typography>
        <TrackedButton
          trackLabel="workflowPlanning.failedPlanning.returnToWorkflow"
          onClick={onClickReturnToWorkflow}
          variant="contained"
          color="primary"
        >
          Return to workflow
        </TrackedButton>
      </Stack>
    </Stack>
  );
};

export default PreviewPlanningFailedDisplay;
